import FullReportBuilder from './FullReportBuilder'

export default FullReportBuilder
